import {useParams} from 'react-router-dom';
import {JKUserFreeLogManager} from './FreeLog/Manager';

export const JKUserDetail = () => {
  const {id} = useParams<any>();
  return <JKUserFreeLogManager jkUserId={id} />;
};
